import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { registerLocaleData } from '@angular/common';
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import localeFr from '@angular/common/locales/fr';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { httpErrorInterceptor } from './app/interceptors/http-error.interceptor';
import { httpLoadingInterceptor } from './app/interceptors/http-loading.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { CATALOG_PROVIDER, InMemoryCatalogProvider } from './app/catalog';
import { httpSuccessInterceptor } from './app/interceptors/http-success.interceptor';

registerLocaleData(localeFr);

export const MY_DATE_FORMATS = {
  parse: { dateInput: 'dd.MM.yyyy' },
  display: {
    dateInput: 'dd.MM.yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd.MM.yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

window.addEventListener('scroll', () => {
  document.body.classList.toggle('scrolled', window.scrollY > 4);
});

// document.addEventListener('focusin', (e) => {
//   if (e.target instanceof HTMLElement && e.target.matches('input, textarea, select')) {
//     const fs = getComputedStyle(e.target).fontSize;
//     const scale = (window as any).visualViewport?.scale;
//     console.log('iOS focus → font-size=', fs, ' viewport scale=', scale);
//   }
// });

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(MatSnackBarModule),
    provideHttpClient(withInterceptors([httpLoadingInterceptor, httpSuccessInterceptor, httpErrorInterceptor])),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic', density: -2 },
    },
    { provide: CATALOG_PROVIDER, useValue: InMemoryCatalogProvider },
  ],
});
